<template>
    <v-sheet>
        <div class="text-subtitle-1 font-weight-bold text-center">Materials</div>

        <v-data-table density="compact" color="primary" :fixed-header="true" :headers="tableHeaders" :items="materialList">
            <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                <tr>
                    <template v-for="column in columns" :key="column.key">
                        <th class="text-no-wrap bg-primary">
                            <span class="mr-2 cursor-pointer" @click="() => toggleSort(column)">{{ column.title }}</span>
                            <template v-if="isSorted(column)">
                                <v-icon :icon="getSortIcon(column)" size="0.875rem"></v-icon>
                            </template>
                        </th>
                    </template>
                </tr>
            </template>
            <template v-slot:item.PartNum="{ value }">
                <div class="text-no-wrap">{{value}}</div>
            </template>
            <template v-slot:item.Description="{ value }">
                <div class="text-truncate" style="max-width: 200px;">
                    {{ value }}
                    <v-tooltip
                        activator="parent"
                        location="bottom"
                    >
                        {{ value }}
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>

    </v-sheet>
</template>

<script>
import {useJobEntryStore} from "../../../../../../stores/ProjectManagement/JobEntry";
import {ref, computed} from "vue";

export default {
    name: "ListWindow",
    setup() {
        const jobEntryStore = useJobEntryStore();

        const tableHeaders = ref([
            { title: 'Mtl', key: 'MtlSeq' },
            { title: 'Part', key: 'PartNum' },
            { title: 'Rev', key: 'RevisionNum' },
            { title: 'Desc', key: 'Description' },
            { title: 'Added Material', key: 'AddedMtl' },
            { title: 'Rel Opr.', key: 'RelatedOperation' },
            { title: 'Qty/Parent', key: 'QtyPer' },
            { title: 'UOM', key: 'IUM' },
            { title: 'Fixed Qty', key: 'FixedQty' },
            { title: 'Find Number', key: 'FindNum' },
            { title: 'Reassign Serial Number to Assembly', key: 'ReassignSNAsm' },
            { title: 'GeneralPlanInfo', key: 'GeneralPlanInfo' },
            { title: 'EstStdDescription', key: 'EstStdDescription' },
            { title: 'PricingUOM', key: 'PricingUOM' },
            { title: 'RemovedFromPlan', key: 'RemovedFromPlan' },
            { title: 'IsPOCostingMaintained', value: 'IsPOCostingMaintained' },
            { title: 'EstStdType', key: 'EstStdType' },
            { title: 'POCostingFactor', key: 'POCostingFactor' },
            { title: 'PlannedQtyPerUnit', key: 'PlannedQtyPerUnit' },
            { title: 'POCostingDirection', key: 'POCostingDirection' },
            { title: 'POCostingUnitVal', key: 'POCostingUnitVal' },
            { title: 'IsMtlConfigurationOn', key: '???' }, //TODO: find out where is this stored
            { title: 'EnableConfigure', key: '???' }, //TODO: find out where is this stored
            { title: 'IsMtlRevisionApproved', key: '???' }, //TODO: find out where is this stored
            { title: 'Original Struct Tag', key: 'OrigStructTag' },
            { title: 'Required Qty', key: 'RequiredQty' },
            { title: 'Base UOM', key: 'BaseUOM' },
            { title: 'Original Group Sequence', key: 'OrigGroupSeq' },
            { title: 'Contract ID', key: 'ContractID' },
            { title: 'Part', key: '???' }, //TODO: find out where is this stored
            { title: 'Link To Contract', key: 'LinkToContract' },
            { title: 'Location Viewable', key: 'LocationView' },
            { title: 'Staging Lot Number', key: 'StagingLotNum' },
            { title: 'PCLinkRemoved', key: 'PCLinkRemoved' },
            { title: 'Machine MES Sync Required', key: 'ExternalMESSyncRequired' },
            { title: 'Part', key: '???' }, //TODO: find out where is this stored
            { title: 'Material Weight', key: 'Weight' },
            { title: 'Machine MES Last Sync', key: 'ExternalMESLastSync' },
            { title: 'Weight UOM', key: 'WeightUOM' },
            { title: 'Require Ref Designators', key: 'ReqRefDes' },
            { title: 'Base Part', key: 'BasePartNum' },
            { title: 'Base Rev', key: 'BaseRevisionNum' },
            { title: 'SelectForPicking', key: 'SelectForPicking' },
            { title: 'Staging', key: '???' }, //TODO: find out where is this stored
            { title: 'Loaned Qty', key: 'LoanedQty' },
            { title: 'Stage Bin', key: 'StagingBinNum' },
            { title: 'Borrowed Qty', key: 'BorrowedQty' },
            { title: 'PickError', key: 'PickError' },
            { title: 'Price Per Code', key: 'PricePerCode' },
            { title: 'PartExists', key: '???' }, //TODO: find out where is this stored
            { title: 'Site List', key: 'Plant' },
            { title: 'Currency Code', key: 'BorrowedQty' },
            { title: 'IsMtlExtConfig', key: 'BorrowedQty' },
            { title: 'EnableDirect', key: 'BorrowedQty' },
            { title: 'Name', key: '???' }, //TODO: find out where is this stored
            { title: 'Misc. Charge', key: 'MiscCharge' },
            { title: 'Service Call Reason', key: '???' }, //TODO: find out where is this stored
            { title: 'Service Call Misc. Charge', key: '???' }, //TODO: find out where is this stored
            { title: 'Prefix', key: '???' }, //TODO: find out where is this stored
            { title: 'Suffix', key: '???' }, //TODO: find out where is this stored
            { title: 'Starting Number', key: '???' }, //TODO: find out where is this stored
            { title: 'Ending Number', key: '???' }, //TODO: find out where is this stored
            { title: 'Changed', key: '???' }, //TODO: find out where is this stored
        ])
        const materialList = computed(() => jobEntryStore.currentAssemblyMaterials ?? []);

        return {
            tableHeaders,
            materialList,
        }
    }
}
</script>

<style scoped>

</style>
